import {useQuery} from '@tanstack/react-query';
// import {calculate_dates} from '../functions/calculate_date';
import useWorkflowStore from '../store';
import {apiService} from '@/lib/ApiService';
import {defaultQueryOptions} from '@/pages/_utils';
import {BaseKey, useList} from '@refinedev/core';
import {useEffect, useState} from 'react';
import {newNode} from '../nodes/utils';
import {normalize_workflow_nodes} from '../utils/auto_calculate_dates';

///////// load workflow of project and tasks (nested)
export const useLoadTaskWorkflow = (task_id?: BaseKey) => {
  const {
    setProjectId,
    setTaskId,
    setNodes,
    setEdges,
    setViewport,
    setNoNodeTasks,
    setTimelineMarkers,
    clearChanges,
    clearData,
  } = useWorkflowStore();
  // load data
  const loadWorkflow = useQuery({
    queryKey: ['workflow-query', 'tasks', String(task_id) || ''],
    queryFn: async () => {
      if (!task_id) return;
      return await apiService.tasks.loadWorkflow(task_id);
    },
    ...defaultQueryOptions,
  });

  // const [loaded, setLoaded] = useState(false);
  // load task list, update data for nodes
  useEffect(() => {
    if (!task_id || !loadWorkflow.data) return;
    clearData();

    const taskList = loadWorkflow.data?.tasks; //useTaskList.data?.data || [];
    const task = loadWorkflow.data;
    const workflow = loadWorkflow.data?.workflow;
    const nodes = workflow?.nodes || [];
    const edges = workflow?.edges || [];

    setProjectId(task.project_id);
    setTaskId(task.id);

    // timeline markers
    setTimelineMarkers(workflow?.timelineMarkers || []);

    // update edges
    setEdges(edges);

    // update viewport
    if (workflow?.viewport) setViewport(workflow.viewport);

    // update nodes with task data

    nodes.forEach(node => {
      if (node.type === 'task') {
        const task = taskList.find(t => t.uuid === node.id);
        if (task) {
          node.data = {
            ...node.data,
            ...task,
            start_date: task.start_date ? new Date(task.start_date) : null,
            initial_end_date: task.initial_end_date ? new Date(task.initial_end_date) : null,
            actual_end_date: task.actual_end_date ? new Date(task.actual_end_date) : null,
            rescheduled_end_date: task.rescheduled_end_date
              ? new Date(task.rescheduled_end_date)
              : null,
          };
        } else {
          // remove node if task not found
          node.data.name = `(Deleted)`;
        }
      }
    });

    // check if start node is missing
    let start_node = nodes.find(n => n.type === 'start');
    if (!start_node) {
      start_node = newNode({
        type: 'start',
        position: {x: 0, y: 0},
        data: {start_date: task.start_date},
      });
      nodes.push(start_node);
    }
    // make sure start_date is project start date
    start_node.data = {...start_node.data, start_date: task.start_date};

    setNodes(nodes);
    setNoNodeTasks(taskList.filter(t => !nodes.some(n => n.id === t.uuid)));

    const {nodes: newNodes, edges: newEdges} = normalize_workflow_nodes(
      nodes.filter(n => n.data.name != '(Deleted)'),
      edges,
    );
    setNodes(newNodes);
    setEdges(newEdges);

    // clear dirty objects because it is newly loaded
    clearChanges();

    // marked loaded
    console.log('workflow loaded', workflow, taskList);
    // setLoaded(true);
  }, [loadWorkflow.data, task_id]);

  return {loadWorkflow, tasks: loadWorkflow.data?.tasks || []};
};
